import { NavLink } from "react-router-dom";
import { SquaresFour, Package, CurrencyCircleDollar, Users, MagnifyingGlass, FileText } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export const BottomNav = () => {
  const { user } = useAuth();
  const items = [
    user?.role === "vendedor"
      ? { to: "/orcamentos", label: "Orçam.", icon: FileText, testId: "bottom-nav-quotes" }
      : { to: "/", label: "Início", icon: SquaresFour, testId: "bottom-nav-home" },
    { to: "/pedidos", label: "Pedidos", icon: Package, testId: "bottom-nav-orders" },
    { to: "/financeiro", label: "Financeiro", icon: CurrencyCircleDollar, testId: "bottom-nav-finance" },
    { to: "/clientes", label: "Clientes", icon: Users, testId: "bottom-nav-clients" },
    { to: "/consulta", label: "Buscar", icon: MagnifyingGlass, testId: "bottom-nav-search" },
  ];
  return (
    <nav data-testid="bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-zinc-950/95 backdrop-blur border-t border-zinc-800 grid grid-cols-5"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      {items.map(({ to, label, icon: Icon, testId }) => (
        <NavLink key={to} to={to} end={to === "/"} data-testid={testId}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] text-[10px] font-medium transition-colors ${
              isActive ? "text-indigo-400" : "text-zinc-500 hover:text-zinc-300"
            }`}>
          {({ isActive }) => (
            <>
              <Icon size={22} weight={isActive ? "fill" : "regular"} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
